import { useMemo } from "react";

import { Copy } from "components/icons/generated";
import { TableCellAction } from "ds/components/Table/Row/CellContent";
import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import useCopyToClipboard from "hooks/useCopyToClipboard";
import { Plugin } from "types/generated";

const PluginsTableLabelIdentifierCell = ({
  item: plugin,
  ...cellProps
}: TableSimpleCellProps<Plugin>) => {
  const copyAction = useCopyToClipboard(plugin.labelIdentifier);

  const actions: TableCellAction[] = useMemo(
    () => [
      {
        icon: Copy,
        title: "Copy",
        onPress: copyAction,
      },
    ],
    [copyAction]
  );

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      <TableCellText>{plugin.labelIdentifier}</TableCellText>
    </TableSimpleCell>
  );
};

export default PluginsTableLabelIdentifierCell;
